import {
  SOAP_SECTION_KEYS,
  type SoapContent,
  type SoapSectionKeys,
} from '@/shared/types/yakurekiSoap'

// 行の印の key (節と行の位置)
export const soapLineKey = (section: SoapSectionKeys, index: number) =>
  `${section}:${index}`

// 行の DOM id (変わった行の先頭へ scroll する先)
export const soapLineDomId = (lineKey: string) => `soap-line-${lineKey}`

// AI で改善した後の SOAP で、前に無かった文の行 (置き換わった・足された行)。消えた行は印を付ける先が無いので数えない。
// 同じ節の前の版に同じ文があれば、位置がずれても変わっていない扱い。
export const changedSoapLines = (
  before: Partial<SoapContent> | null | undefined,
  after: SoapContent
): Set<string> => {
  const changed = new Set<string>()
  for (const section of SOAP_SECTION_KEYS) {
    const old = new Set((before?.[section] ?? []).map((item) => item.content))
    ;(after[section] ?? []).forEach((item, i) => {
      if (!old.has(item.content)) changed.add(soapLineKey(section, i))
    })
  }
  return changed
}
